import React, { useEffect } from 'react';
import classNames from 'classnames';
import { stub as $t } from '@nbcnews/analytics-framework';
import styles from './styles.module.scss';

/**
 * Renders a list of links that jump to sections within the page.
 *
 * @param {object} props - Component props.
 * @param {Function} props.callback
 * @param {string} props.clickTrackingId
 * @param {Array} [props.links]
 * @param {string} props.testId
 * @param {string} [props.activeLink=""]
 * @returns {React.ReactElement|null} - The rendered component or null.
 */
const JumpLinkList = ({
  activeLink = '',
  callback = () => {},
  clickTrackingId = 'mbt_jump_links',
  links = [],
  testId = 'jump-link-list',
}) => {
  useEffect(() => {
    $t('register', clickTrackingId, { allowDuplicate: true });
  }, []);

  if (!links.length) {
    return null;
  }

  /**
   * Handle click tracking and callbacks when the user clicks on a link.
   *
   * @param {object} e - The click event.
   */
  const handleOnClick = (e) => {
    e.preventDefault();

    e.stopPropagation();

    callback();

    $t('track', clickTrackingId, { action: 'jumpLink', name: e.target.textContent });

    window.location.href = e.target.href;
  };

  return (
    <ul
      className={styles.jumpLinkList}
      data-testid={testId}
    >
      {links.map((link, index) => (
        <li
          className={classNames(
            styles.jumpLinkList__item,
            { [styles.jumpLinkList__activeItem]: activeLink === link.href },
          )}
          key={link.href}
        >
          <a
            className={styles.jumpLinkList__itemLink}
            data-testid={`jump-link-list__item-link-${index}`}
            href={link.href}
            onClick={handleOnClick}
          >
            {link.linkText}
          </a>
        </li>
      ))}
    </ul>
  );
};

export { JumpLinkList };
